import { combineReducers } from "redux";
import { merge } from "lodash";
import { normalize, schema } from "normalizr";

const signupcompcreateSchema = new schema.Entity("signupcompcreate", {}, { idAttribute: "id" });
const defaultParams = {
  isSaving: false,
  otpFetching:false,
  pwValidating:false,
  otpValidating:false,
  };

  function ByType(state = defaultParams, action) {
    if ((action.type === "SAVE_SIGNUPCOMPCREATE_DATA" || action.type === "FINALDOMAINCREATION") && action.payload?.curState != 1) {
      return {...state, isSaving: true};
    }else if (action.type === "FETCHOTPATMAILID") {
      return { ...state, otpFetching: true};
    }else if(action.type == "VALIDATINGPASSWORD"){
      return { ...state, pwValidating: true};
    }else if(action.type == "VALIDATINGOTP"){
      return { ...state, otpValidating: true};
    }else if(action.type == "FINALDOMAINCREATIONSTATUS"){
      return { ...state, finalstepcomplete: true, isSaving: false};
    }else if(action.type == "SAVED_SIGNUPCOMPCREATE_DATA" && action.payload.data.curState != 8){
      return { ...state, isSaving: false};
    }else if(action.type == "FETCHEDOTPATMAILID"){
      return { ...state, otpFetching: false};
    }else if (action.type === "VALIDATEDPASSWORD") {
      return { ...state, pwValidating: false};
    }else if (action.type === "VALIDATEDOTP") {
      return { ...state, otpValidating: false};
    }else {
      return state;
    }
  }
  
  function ByProfit(state = defaultParams  , action) {
    if (action.type === "SAVED_SIGNUPCOMPCREATE_DATA") {
      return {
        ...state,
       byEmailData : action.payload
      }
    }else if (action.type === "SAVED_SIGNUPCOMPCREATE_DATA_BY_EMAIL") {
      return {
        ...state,
       byEmailData : action.payload
      }
    }else if (action.type === "FETCHEDOTPATMAILID") {
      return {
        ...state,
        otpSent : action.payload
      }
    }else if (action.type === "VALIDATEDPASSWORD") {
      return {
        ...state,
       validatedpw : action.payload
      }
    }else if (action.type === "VALIDATEDOTP") {
      return {
        ...state,
       validatedotp : action.payload
      }
    }else if (action.type === "CHECKEDIFDATASAVED") {
      return {
        ...state,
        isDataAlreadySavedChkObj : action.payload?.data
      }
    }else if (action.type === "FINALDOMAINCREATIONSTATUS") {
      return {
        ...state,
        finalDomainCreationDataObj : action.payload?.data
      }
    } else {
      return state;
    }
  }
  const signupCompCreate = combineReducers({
    ByType,
    ByProfit
  });
  
  export default signupCompCreate;